import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const coverSizes = {
    small: 'w-[140px] h-[187px]',
    medium: 'w-[170px] h-[227px]',
    large: 'w-[200px] h-[267px]',
  };

  const titleSizes = {
    small: 'text-sm',
    medium: 'text-sm md:text-base',
    large: 'text-base',
  };

  return (
    <Link
      to={`/article/${comic.slug}`}
      className="group block"
    >
      <div className={`${coverSizes[size]} relative overflow-hidden rounded-lg mb-2.5 bg-background-200`}>
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 免费韩漫`}
          title={`${comic.title} - 免费韩漫下拉式阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        {comic.status === '连载中' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium rounded-full bg-primary-500 text-background-50">
            连载
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium rounded-full bg-accent-500 text-background-50">
            完结
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="flex items-center gap-1.5 text-[10px] text-background-50">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-accent-400 text-[10px]"></i>
            </div>
            <span>{comic.rating}</span>
            <span className="mx-0.5">·</span>
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-eye-line text-[10px]"></i>
            </div>
            <span>{(comic.views / 10000).toFixed(0)}万</span>
          </div>
        </div>
      </div>
      <h3 className={`${titleSizes[size]} font-medium text-foreground-800 line-clamp-1 group-hover:text-primary-500 transition-colors`}>
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{comic.author}</p>
    </Link>
  );
}